import { render } from "./TongueTwister.vue?vue&type=template&id=62b25945"
import script from "./TongueTwister.vue?vue&type=script&lang=js"
export * from "./TongueTwister.vue?vue&type=script&lang=js"

import "./TongueTwister.vue?vue&type=style&index=0&id=62b25945&lang=scss"
script.render = render

export default script